export default __webpack_public_path__ + "static/media/salaries.fab03626.png";